import React from 'react';
import { func, number, string } from 'prop-types';
import classNames from 'classnames';

import css from '../SearchMapGroupLabel/SearchMapGroupLabel.module.css';

/**
 * Count bubble for a geographic cluster. Clicking zooms in so the cluster
 * splits; it does not open a listing card (the members are not loaded yet).
 */
const SearchMapClusterLabel = props => {
  const { className, rootClassName, count, lat, lng, expansionZoom, onClusterClicked } = props;
  const classes = classNames(rootClassName || css.root, className);
  const label = count === 1 ? '1 event' : `${count.toLocaleString()} events`;

  return (
    <button
      type="button"
      className={classes}
      title={label}
      aria-label={label}
      onClick={event => {
        event.preventDefault();
        event.stopPropagation();
        onClusterClicked({ lat, lng, expansionZoom, count });
      }}
    >
      <div className={css.caretShadow} />
      <div className={css.details}>{count.toLocaleString()}</div>
      <div className={css.caret} />
    </button>
  );
};

SearchMapClusterLabel.defaultProps = {
  className: null,
  rootClassName: null,
};

SearchMapClusterLabel.propTypes = {
  className: string,
  rootClassName: string,
  count: number.isRequired,
  lat: number.isRequired,
  lng: number.isRequired,
  expansionZoom: number.isRequired,
  onClusterClicked: func.isRequired,
};

export default SearchMapClusterLabel;
